<template>
<div class="page_smart_park page_hezuo">
	<div class="form_wrap">
		<div class="item flex">
			<div class="item_l">
				<div class="title">是否通票</div>
				<van-field v-model="ticket_type" placeholder="请选择" readonly/>
			</div>
			<div class="item_r" @click="ticketTypePicker = true">选择</div>
		</div>
	</div>
	<div class="form_wrap" v-if="!is_through_ticket">
		<div class="item flex">
			<div class="item_l">
				<div class="title">选择参观馆</div>
				<van-field v-model="venue_name" placeholder="请选择" readonly/>
			</div>
			<div class="item_r" @click="venuePicker = true">选择</div>
		</div>
	</div>
	<!-- 次卡列表 -->
	<div class="cardlist">
		<div :class="item.is_select ? 'item selected' : 'item'" v-for="item in cardList" :key="item.id" @click="selectCard(item)">
			<div class="item_l">{{ item.name }}</div>
			<div class="item_r">{{ '¥'+ item.price }}</div>
		</div>
		<!-- <div class="item selected">
			<div class="item_l">一次卡</div>
			<div class="item_r"> ¥60.00</div>
		</div> -->
	</div>
	<div class="bottom">
		<div class="action big" @click="toBuyCard">购买</div>
	</div>
	<!-- 是否通票 -->
	<van-popup v-model="ticketTypePicker" position="bottom">
		<van-picker
			show-toolbar
			:columns="ticketTypeList"
			value-key="text"
			@cancel="ticketTypePicker = false"
			@confirm="confrimTicketType"
		/>
    </van-popup>
	<!-- 场馆列表 -->
	<van-popup v-model="venuePicker" position="bottom">
		<van-picker
			show-toolbar
			:columns="venueList"
			value-key="title"
			@cancel="venuePicker = false"
			@confirm="confrimVenue"
		/>
    </van-popup>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smartpark-card-list",
    data() {
        return {
            publicPath: process.env.BASE_URL,
			venuePicker: false, // 选择场馆弹层
			venue_name: null, // 场馆名称
			venue_id: null, // 场馆ID
			venueList: null, // 场馆列表
			is_through_ticket: 0, // 是否通票
			ticket_type: '否',
			ticketTypePicker: false,
			ticketTypeList: [
				{
					id: 1,
					is_through_ticket: 1,
					text: '是'
				},
				{
					id: 2,
					is_through_ticket: 0,
					text: '否'
				},
			],
			cardList: null, // 次卡列表
			currentCard: null, // 当前选中的卡
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '次卡',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						// 场馆列表
						this.getVenueList()
                    } else {
                        this.token = "";
						// 场馆列表
						this.getVenueList()
                    }
                    // 调用某方法
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			// 场馆列表
			this.getVenueList()
        }
        
    },
	mounted() {
	},
    methods: {
		// 场馆列表
		getVenueList(){
			var that = this
			var params = {
				token: that.token,
				id: 1 // 园区ID(目前只有一个园区,直接写死的)
			}
			that.$api.smartpark.venuelist(params).then(res=>{
				if(res.code == 200){
					that.venueList = res.result
					that.venue_name = that.venueList[0].title
					that.venue_id = that.venueList[0].id
					that.getCardList()
				}
			})
		},
		// 选择场馆
		confrimVenue(value){
			var that = this
			that.venue_name = value.title
			that.venue_id = value.id
			that.venuePicker = false
			that.getCardList()
			// console.log('展馆',value)
		},
		// 选择通票
		confrimTicketType(value){
			var that = this
			that.ticket_type = value.text
			that.is_through_ticket = value.is_through_ticket
			that.ticketTypePicker = false
			that.getCardList()
		},
		// 次卡
		getCardList(){
			var that = this
			var params = {}
			// 是否通票
			if(that.is_through_ticket != null){
				params.is_through_ticket = that.is_through_ticket
				that.venue_id = null
			}
			// 场馆ID
			if(that.venue_id){
				params.venue_id = that.venue_id
			}
			that.$api.smartpark.timescardlist(params).then(res=>{
				if(res.code == 200){
					var list = res.result
					for(var i in list){
						list[i].is_select = false
					}
					that.cardList = list
				}
			})
		},
		// 选卡
		selectCard(item){
			var that = this
			var list = that.cardList
			for(var i in list){
				if(list[i].id == item.id){
					list[i].is_select = true
					that.currentCard = list[i]
				}else{
					list[i].is_select = false
				}
			}
			that.cardList = []
			that.cardList = list
		},
		// 购买次卡
		toBuyCard(){
			var that = this
			if(!that.currentCard){
				that.$toast('请选择要购买的次卡')
				return
			}
			var params = {
				token: that.token,
				times_card_id: that.currentCard.id
			}
			that.$api.smartpark.timescardbuy(params).then(res=>{
				if(res.code == 200){
					var that = this
					if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
						var params = {
							'data': {
								'url': that.$publicData.clientUrl + '/smartpark/pay?pay_order_num='+res.result.pay_order_num+'&price='+res.result.total_prices+'&order_id='+res.result.id+'&is_timescard=1'
							}
						}
						that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

						})
					} else {
						that.$router.push({
							path: '/smartpark/pay',
							query: {
								pay_order_num: res.result.pay_order_num, // 支付订单号
								price: res.result.total_prices,
								order_id: res.result.id, // 订单id
								is_timescard: 1 // 次卡标志
							}
						})
					}
					
				}
			})
		}
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
